import React from 'react';
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import ConfirmDialog from './ConfirmDialog';
import { useConfirmDialog } from '../hooks/useConfirmDialog';

interface ExtraContentComponentProps {
    node: any;
    updateAttributes: (attributes: Record<string, any>) => void;
    selected: boolean;
    deleteNode: () => void;
    editor: any;
}

const ExtraContentComponent: React.FC<ExtraContentComponentProps> = ({
    node,
    updateAttributes,
    selected,
    deleteNode,
    editor,
}) => {
    const { dialogState, showConfirm } = useConfirmDialog();

    const handleDelete = async () => {
        const confirmed = await showConfirm({
            title: 'Delete Extra Content',
            message: 'Are you sure you want to delete this extra content box?\n\nThis action cannot be undone.',
            confirmText: 'Delete',
            cancelText: 'Cancel',
            isDestructive: true
        });

        if (confirmed) {
            deleteNode();
        }
    };

    const isEmpty = !node.content || node.content.size === 0 ||
        (node.content.size === 1 &&
            node.content.firstChild?.type.name === 'paragraph' &&
            node.content.firstChild?.content.size === 0);

    return (
        <NodeViewWrapper className={`extra-content-wrapper ${selected ? 'selected' : ''}`}>
            <div className="extra-content-box">
                <div className="extra-content-header">
                    <span className="extra-content-label">📝 Extra Content</span>
                    <div className="extra-content-actions">
                        <button
                            className="extra-content-delete-btn"
                            onClick={handleDelete}
                            title="Delete this box"
                        >
                            🗑️
                        </button>
                    </div>
                </div>

                <div className="extra-content-body">
                    <div className="extra-content-editor">
                        <NodeViewContent
                            className="extra-content-content"
                            style={{ minHeight: '60px' }}
                        />
                        {isEmpty && (
                            <div className="extra-content-placeholder">
                                Click here to add extra content...
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <ConfirmDialog
                isOpen={dialogState.isOpen}
                onConfirm={dialogState.onConfirm}
                onCancel={dialogState.onCancel}
                title={dialogState.title}
                message={dialogState.message}
                confirmText={dialogState.confirmText}
                cancelText={dialogState.cancelText}
                isDestructive={dialogState.isDestructive}
            />
        </NodeViewWrapper>
    );
};

export default ExtraContentComponent; 